import 'bootstrap/dist/css/bootstrap.min.css'
import './static/styles/general.css'

import CustomLayout from './wrapPageElement'

export const wrapPageElement = CustomLayout
